import { styled } from 'linaria/react';

export const MainProductBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-150);
`;

export const MainProductContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-400);
  width: 100%;

  @media (--only-mobile) {
    flex-direction: column;
    gap: var(--space-200);
  }
`;

export const MainProductImageAndName = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-100);
  width: 64.5%;

  @media (--only-mobile) {
    width: 100%;
  }
`;
export const CounterAndPriceContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  grid-gap: var(--space-100);
  gap: var(--space-100);
  width: 36.5%;

  @media (--only-mobile) {
    width: 100%;
  }
`;

export const PriceColumnContainer = styled.div`
  white-space: nowrap;

  @media (--only-mobile) {
    order: 1;
  }
`;
